export const openModal = (type, payload = {}) => {
  return { type: `${type}_OPEN_MODAL`, payload };
};

export const closeModal = (type) => {
  return { type: `${type}_CLOSE_MODAL` };
};
